import React, {Component} from 'react';
import Title from '../base/title';
import ClusterStrategyFull from './clusterstrategy-full';
import ClusterStrategyShort from './clusterstrategy-short';

export default class ClusterStrategy extends Component {

    constructor(props) {
        super(props);
        this.state = {expanded: false};
        this.toggle = this.toggle.bind(this);
        this.checkNewRefPrice = this.props.checkNewRefPrice.bind(this);
        this.checkIncreasePrice = this.props.checkIncreasePrice.bind(this);
    }

    toggle() {
        this.setState({expanded : !this.state.expanded});
    }

    render() {
        let _self = this;
        let data = _self.props.data;

        return <div className="">
            <Title toggle={this.toggle} text={data.name} isGray={true} hasIcon={true} />
            {this.state.expanded ? <ClusterStrategyFull checkIncreasePrice={_self.props.checkIncreasePrice} checkFinalSimulation={_self.props.checkFinalSimulation} checkNewRefPrice={_self.props.checkNewRefPrice} data={data}/> : <ClusterStrategyShort data={data}/>}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/containers/simulador/clusterstrategy.js